"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NjordsLullabyAbilityHandler = exports.NjordsLullabyActorAbilityFactory = exports.NjordsLullabyAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EffectType_1 = require("../../core/effects/EffectType");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const ts_essentials_1 = require("ts-essentials");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class NjordsLullabyAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NjordsLullaby;
        this.__typeName = "NjordsLullaby";
    }
}
exports.NjordsLullabyAbilityArgs = NjordsLullabyAbilityArgs;
let NjordsLullabyActorAbilityFactory = class NjordsLullabyActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NjordsLullaby", "OneEnemies", 4);
    }
};
NjordsLullabyActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NjordsLullaby")
], NjordsLullabyActorAbilityFactory);
exports.NjordsLullabyActorAbilityFactory = NjordsLullabyActorAbilityFactory;
let NjordsLullabyAbilityHandler = class NjordsLullabyAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        (0, ts_essentials_1.assert)(!container.hasEffectOfType(selectedEnemy, EffectType_1.EffectType.Charmed), "100|CannotCharmAnAlreadyCharmedFoe");
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_1.CharmedEffectArgs(),
                    onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "head", "front"), 
                    // TODO: better vfx
                    "LightPinkVaporBurst"))
                });
            }
        });
    }
};
NjordsLullabyAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NjordsLullaby)
], NjordsLullabyAbilityHandler);
exports.NjordsLullabyAbilityHandler = NjordsLullabyAbilityHandler;
